import {Serialisable} from "../../../services/serialisable";
import {TreeNode} from "../../../services/dtos/interfaces/tree-node";
import {ConfigLevelType} from "../../../services/dtos/enums/config-level-type.enum";

export class RootDeploymentNode extends Serialisable implements TreeNode {
    children: TreeNode[];
    configLevel: ConfigLevelType = ConfigLevelType.RootNode;

    getChildren(): TreeNode[] {
        return this.children;
    }
    setChildren(value: TreeNode[]): void {
        this.children = value;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/components/deployment/deployment-tree/root-deployment-node.ts